export default __webpack_public_path__ + "static/media/search-default-image.57b99492.png";